import { jsx as _jsx } from "react/jsx-runtime";
import { PaginationContainer } from './styles';
import { Icon } from '../Icon';
export function Pagination({ disabled, waiting, totalPages, page, onPaginate }) {
    const arrowColor = disabled ? '--text-primary' : '--text-link';
    return (_jsx(PaginationContainer, { disabled: disabled, waiting: waiting, forcePage: page || 0, previousLabel: _jsx(Icon, { name: "chevron_left", color: arrowColor }), nextLabel: _jsx(Icon, { name: "chevron_right", color: arrowColor }), onPageChange: ({ selected }) => onPaginate?.(selected), breakLabel: "...", pageCount: totalPages, pageRangeDisplayed: 3, marginPagesDisplayed: 1 }));
}
//# sourceMappingURL=index.js.map